export class Emoji {
    id: number;
    image: string;
    imageHost: string;
    title: string;
    symbol: string;

    get html() {
        return '<img src="' + this.imageHost + this.image + '"' + ' title="' + this.title + '" />';
    }
}
